
  var _styles = {
  "unused-free-order-main-card__container": {
    "width": "9.36rem",
    "height": "6.37333rem",
    "borderRadius": "0.48rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "overflow": "hidden",
    "position": "relative"
  },
  "unused-free-order-main-card__background": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "6.32rem",
    "borderRadius": "0.48rem",
    "zIndex": 0
  },
  "unused-free-order-main-card__wrapper": {
    "width": "9.36rem",
    "height": "6.37333rem",
    "position": "relative",
    "zIndex": 1,
    "borderRadius": "0.48rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "unused-free-order-main-card__city-wrapper": {
    "marginTop": "0.32rem",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "unused-free-order-main-card__city-img": {
    "width": "0.42667rem",
    "height": "0.42667rem"
  },
  "unused-free-order-main-card__city-text": {
    "marginLeft": "0.16rem",
    "fontWeight": "500",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem"
  },
  "unused-free-order-main-card__title-wrapper": {
    "marginTop": "0.37333rem",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "unused-free-order-main-card__title-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "marginBottom": "-0.32rem"
  },
  "unused-free-order-main-card__amount-wrapper": {
    "width": "100%",
    "overflow": "visible",
    "flexDirection": "row",
    "alignItems": "baseline",
    "justifyContent": "center"
  },
  "unused-free-order-main-card__amount-prefix": {
    "color": "rgb(255,85,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.8rem"
  },
  "unused-free-order-main-card__amount-content": {
    "color": "rgb(255,85,0)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "1.6rem"
  },
  "unused-free-order-main-card__use-button": {
    "width": "5.33333rem",
    "height": "1.28rem",
    "position": "absolute",
    "bottom": "0.85333rem",
    "borderRadius": "0.8rem",
    "justifyContent": "center",
    "alignItems": "center",
    "backgroundColor": "rgb(255,231,77)"
  },
  "unused-free-order-main-card__use-button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "textAlign": "center"
  },
  "unused-free-order-main-card__expire-desc-wrapper": {
    "marginTop": "-0.2rem",
    "width": "100%",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "unused-free-order-main-card__expire-desc-text": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center"
  },
  "unused-free-order-main-card__notice-slider-wrapper": {
    "width": "100%",
    "height": "0.85333rem",
    "position": "absolute",
    "bottom": 0
  },
  "used-free-order-main-card__container": {
    "width": "9.36rem",
    "borderRadius": "0.32rem",
    "position": "relative",
    "padding": "0.13333rem",
    "overflow": "hidden"
  },
  "used-free-order-main-card__background": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.30667rem",
    "height": "98%",
    "borderRadius": "0.32rem"
  },
  "used-free-order-main-card__wrapper": {
    "position": "relative",
    "zIndex": 1,
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "width": "9.36rem",
    "paddingTop": "0.4rem",
    "paddingRight": 0,
    "paddingBottom": "0.4rem",
    "paddingLeft": 0,
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "used-free-order-main-card__left-wrapper": {
    "marginLeft": "0.32rem",
    "maxWidth": "6rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start"
  },
  "used-free-order-main-card__left-title-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "maxWidth": "6rem"
  },
  "used-free-order-main-card__left-desc-text": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "textAlign": "center"
  },
  "used-free-order-main-card__tag-wrapper": {
    "width": "2.34667rem",
    "height": "1.88rem",
    "position": "absolute",
    "top": "-0.2rem",
    "right": 0,
    "zIndex": 0
  },
  "used-free-order-main-card__tag-img": {
    "width": "2.34667rem",
    "height": "1.88rem"
  },
  "used-free-order-main-card__amount-wrapper": {
    "width": "4rem",
    "position": "absolute",
    "flexDirection": "row",
    "justifyContent": "flex-end",
    "alignItems": "baseline",
    "right": "0.26667rem",
    "zIndex": 1
  },
  "used-free-order-main-card__amount-prefix": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.32rem"
  },
  "used-free-order-main-card__amount-content": {
    "color": "rgb(17,17,17)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "0.64rem",
    "textAlign": "left"
  }
};



  module.exports = _styles;
  